import { render, staticRenderFns } from "./BaggageAttachComponent.vue?vue&type=template&id=38958a8d&scoped=true"
import script from "./BaggageAttachComponent.vue?vue&type=script&lang=js"
export * from "./BaggageAttachComponent.vue?vue&type=script&lang=js"
import style0 from "./BaggageAttachComponent.vue?vue&type=style&index=0&id=38958a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38958a8d",
  null
  
)

export default component.exports